import {useMutation} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {toast} from '@common/ui/toast/toast';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {message} from '@common/i18n/message';
import {apiClient} from '@common/http/query-client';

interface Response extends BackendResponse {}

export interface ChangeEmailPayload {
  password: string;
  email: string;
}

export function useChangeEmail(form: UseFormReturn<ChangeEmailPayload>) {
  return useMutation({
    mutationFn: (props: ChangeEmailPayload) => changeEmail(props),
    onSuccess: () => {
      toast(message('Confirmation link sent to your new email address'));
    },
    onError: r => onFormQueryError(r, form),
  });
}

function changeEmail(payload: ChangeEmailPayload): Promise<Response> {
  return apiClient.post('users/me/change-email', payload).then(r => r.data);
}
